__turbopack_context__.v({
  "alignCENTER": "PageBlocks-module__q1z4cW__alignCENTER",
  "alignLEFT": "PageBlocks-module__q1z4cW__alignLEFT",
  "alignRIGHT": "PageBlocks-module__q1z4cW__alignRIGHT",
  "baroquePage": "PageBlocks-module__q1z4cW__baroquePage",
  "block": "PageBlocks-module__q1z4cW__block",
  "blockGrid": "PageBlocks-module__q1z4cW__blockGrid",
  "button": "PageBlocks-module__q1z4cW__button",
  "cmsSiteBody": "PageBlocks-module__q1z4cW__cmsSiteBody",
  "cta": "PageBlocks-module__q1z4cW__cta",
  "datedLink": "PageBlocks-module__q1z4cW__datedLink",
  "footer": "PageBlocks-module__q1z4cW__footer",
  "gallery": "PageBlocks-module__q1z4cW__gallery",
  "galleryThumb": "PageBlocks-module__q1z4cW__galleryThumb",
  "galleryThumbs": "PageBlocks-module__q1z4cW__galleryThumbs",
  "hero": "PageBlocks-module__q1z4cW__hero",
  "heroContent": "PageBlocks-module__q1z4cW__heroContent",
  "heroDate": "PageBlocks-module__q1z4cW__heroDate",
  "heroImage": "PageBlocks-module__q1z4cW__heroImage",
  "image": "PageBlocks-module__q1z4cW__image",
  "lightbox": "PageBlocks-module__q1z4cW__lightbox",
  "lightboxArrow": "PageBlocks-module__q1z4cW__lightboxArrow",
  "lightboxCaption": "PageBlocks-module__q1z4cW__lightboxCaption",
  "lightboxChapter": "PageBlocks-module__q1z4cW__lightboxChapter",
  "lightboxChapterBtn": "PageBlocks-module__q1z4cW__lightboxChapterBtn",
  "lightboxChapters": "PageBlocks-module__q1z4cW__lightboxChapters",
  "lightboxClose": "PageBlocks-module__q1z4cW__lightboxClose",
  "lightboxContent": "PageBlocks-module__q1z4cW__lightboxContent",
  "lightboxCounter": "PageBlocks-module__q1z4cW__lightboxCounter",
  "lightboxImage": "PageBlocks-module__q1z4cW__lightboxImage",
  "lightboxImageWrap": "PageBlocks-module__q1z4cW__lightboxImageWrap",
  "lightboxStage": "PageBlocks-module__q1z4cW__lightboxStage",
  "linkContent": "PageBlocks-module__q1z4cW__linkContent",
  "linkDate": "PageBlocks-module__q1z4cW__linkDate",
  "linkExcerpt": "PageBlocks-module__q1z4cW__linkExcerpt",
  "linkLabel": "PageBlocks-module__q1z4cW__linkLabel",
  "links": "PageBlocks-module__q1z4cW__links",
  "markdown": "PageBlocks-module__q1z4cW__markdown",
  "markdownDate": "PageBlocks-module__q1z4cW__markdownDate",
  "markdownHeader": "PageBlocks-module__q1z4cW__markdownHeader",
  "nav": "PageBlocks-module__q1z4cW__nav",
  "navHome": "PageBlocks-module__q1z4cW__navHome",
  "navHomeIcon": "PageBlocks-module__q1z4cW__navHomeIcon",
  "navLink": "PageBlocks-module__q1z4cW__navLink",
  "navLinkActive": "PageBlocks-module__q1z4cW__navLinkActive",
  "navLinks": "PageBlocks-module__q1z4cW__navLinks",
  "navSep": "PageBlocks-module__q1z4cW__navSep",
  "navTitle": "PageBlocks-module__q1z4cW__navTitle",
  "navVisible": "PageBlocks-module__q1z4cW__navVisible",
  "pageBtn": "PageBlocks-module__q1z4cW__pageBtn",
  "pageInfo": "PageBlocks-module__q1z4cW__pageInfo",
  "pageLoading": "PageBlocks-module__q1z4cW__pageLoading",
  "pagination": "PageBlocks-module__q1z4cW__pagination",
  "preview": "PageBlocks-module__q1z4cW__preview",
  "previewBlock": "PageBlocks-module__q1z4cW__previewBlock",
  "shareBar": "PageBlocks-module__q1z4cW__shareBar",
  "shareBtn": "PageBlocks-module__q1z4cW__shareBtn",
  "shareIcon": "PageBlocks-module__q1z4cW__shareIcon",
  "shareLabel": "PageBlocks-module__q1z4cW__shareLabel",
  "showMore": "PageBlocks-module__q1z4cW__showMore",
  "topOrnament": "PageBlocks-module__q1z4cW__topOrnament",
  "widthFULL": "PageBlocks-module__q1z4cW__widthFULL",
  "widthHALF": "PageBlocks-module__q1z4cW__widthHALF",
  "widthTHIRD": "PageBlocks-module__q1z4cW__widthTHIRD",
  "widthTWO_THIRDS": "PageBlocks-module__q1z4cW__widthTWO_THIRDS",
  "yearHeader": "PageBlocks-module__q1z4cW__yearHeader",
});
